import React from 'react'

const Component = (
  props: Record<string, any>
): React.ReactElement<React.ComponentProps<any>, any> => {
  return (
    <div data-type='catalogHolder'>
      <img
        className='lazyload'
        loading='lazy'
        width='222'
        height='222'
        data-src='//d3t95n9c6zzriw.cloudfront.net/trade/catalog/catalog23.jpg'
        alt='Saatchi For The Trade - Catalog'
        itemProp='image'
      />

      <div data-type='catalog'>
        <h4 className='defaultTypographyH4'>Browse the Saatchi Art Trade Catalog</h4>
        <a href='//d3t95n9c6zzriw.cloudfront.net/trade/brochure/SA-AA-Brochure-2023.pdf?content-disposition=attachment'>
          <button type='button'>Download</button>
        </a>
      </div>
    </div>
  )
}

export default Component
